<h1 mat-dialog-title>
  <ng-container i18n="Invite User Modal|Invite User Modal title@@invite-user-modal-title">
    Invite User
  </ng-container>
</h1>
<div mat-dialog-content #dialogContent class="full-width details-content">
  <permission-checker [roles]="roles" (rolesLoaded)="callerRolesUpdated($event)">
    <div>
      <form [formGroup]="inviteForm" (ngSubmit)="proceed()">
        <div *ngIf="searchMode" i18n="Invite User Modal|Search by email title@@invite-user-modal-search-by-email-title">
          Search existing user by email:
        </div>
        <div *ngIf="!searchMode" i18n="Invite User Modal|Invite new user title@@invite-user-modal-invite-new-title">
          Invite and enroll new user
        </div>

        <span>
          <form-input [control]="roleField"
                      label="Role"
                      i18n-label="Invite User Modal|Invite User Modal role input label@@invite-user-modal-role-input-label"
                      [options]="userRoles"
                      [compareWith]="compareRoles"
                      [displayWith]="displayRole"></form-input>
        </span>

        <mat-slide-toggle *ngIf="searchModeAllowed"
                          class="search-mode-selector"
                          color="primary"
                          (toggleChange)="searchModeChanged()"
                          [checked]="!searchMode">
          <ng-container *ngIf="searchMode"
                        i18n="Invite User Modal|Search for user switcher title@@invite-user-modal-search-for-user-switcher-title">
            Search for User
          </ng-container>
          <ng-container *ngIf="!searchMode"
                        i18n="Invite User Modal|Invite user switcher title@@invite-user-modal-invite-user-switcher-title">
            Invite User
          </ng-container>
        </mat-slide-toggle>
        <mat-slide-toggle *ngIf="usernameModeAllowed"
                          class="search-mode-selector"
                          color="primary"
                          (toggleChange)="usernameModeChanged()"
                          [checked]="!usernameMode">
          <ng-container *ngIf="usernameMode"
                        i18n="Invite User Modal|Invite by username switcher title@@invite-user-modal-invite-by-username-switcher-title">
            Invite without email
          </ng-container>
          <ng-container *ngIf="!usernameMode"
                        i18n="Invite User Modal|Invite by email switcher title@@invite-user-modal-invite-by-email-switcher-title">
            Invite with email
          </ng-container>
        </mat-slide-toggle>

        <span *ngIf="searchMode">
          <item-autocomplete #searchUserEmail
                             label="Email"
                             i18n-label="Invite User Modal|Invite User Modal query input label@@invite-user-modal-query-input-label"
                             placeholder="User email..."
                             i18n-placeholder="Invite User Modal|Invite User Modal query input placeholder@@invite-user-modal-query-input-placeholder"
                             [clearAfterSelect]="false"
                             [displayWith]="displayUser"
                             [searchWith]="searchUsers"
                             (selected)="userSelected($event)"></item-autocomplete>
        </span>

        <span *ngIf="!searchMode">
          <form-input [control]="emailField"
                      label="Email"
                      i18n-label="Invite User Modal|Invite User Modal query input label@@invite-user-modal-query-input-label"
                      placeholder="User email..."
                      i18n-placeholder="Invite User Modal|Invite User Modal query input placeholder@@invite-user-modal-query-input-placeholder"
                      type="email"
                      [minLength]="5" [maxLength]="128"
                      suffixIcon="person_search"
                      suffixTooltip="User account will be searched by email after you enter email and step out of this field"
                      i18n-suffixTooltip="Invite User Modal|Invite User Modal query input tooltip@@invite-user-modal-query-input-tooltip"
                      (focusLost)="verifyUserExists()"></form-input>
        </span>

        <div *ngIf="user || userNotFound || userLoading" class="found-user">
          <div class="user-info">
            <span *ngIf="user && (user.schoolId || userRoles.includes(HOST_ROLE) || userRoles.includes(COORDINATOR_ROLE)) && (!school || user.schoolId == school.id)" class="mat-small text-disabled-color">
              <ng-container i18n="Invite User Modal|User found by email sub title@@invite-user-modal-user-found-by-email-sub-title">User profile found</ng-container>:
            </span>
            <span
              *ngIf="user && !user.schoolId && (userRoles.includes(STUDENT_ROLE) || userRoles.includes(TEACHER_ROLE))"
              class="mat-small color-warn">
              <ng-container
                i18n="Invite User Modal|User found by email (no school) sub title@@invite-user-modal-user-found-by-email-no-school-sub-title">
                User profile found, but his registration is not completed (school not selected)
              </ng-container>
            </span>
            <span *ngIf="school && user && user.schoolId && user.schoolId != school.id" class="mat-small color-warn">
              <ng-container
                i18n="Invite User Modal|User found by email (wrong school) sub title@@invite-user-modal-user-found-by-email-wrong-school-sub-title">
                User profile found, but he is from another
              </ng-container>
              <app-link label="school"
                        i18n-label="Invite User Modal|User found by email (wrong school) details title@@invite-user-modal-user-found-by-email-wrong-school-details-title"
                        (click)="showSchoolDetails(user.schoolId || '')"></app-link>&nbsp;:
            </span>
            <br *ngIf="user"/>
            <mat-spinner *ngIf="userLoading" color="primary" diameter="20"></mat-spinner>
            <span *ngIf="user" class="word-wrap">
              {{displayUser(user)}}
            </span>
            <span *ngIf="!userLoading && !user" class="color-green"
                  i18n="Invite User Modal|User not found by email sub title@@invite-user-modal-user-not-found-by-email-sub-title">
              User profile not found and can be invited.
            </span>
          </div>

          <button mat-button matSuffix mat-icon-button class="remove-selected-btn"
                  (click)="removeSelectedUser()">
            <mat-icon class="info-icon">close</mat-icon>
          </button>
        </div>

        <div fxLayout="row" fxLayout.lt-md="column">
          <form-input fxFlex="48%"
                      [control]="firstNameField"
                      [required]="false"
                      label="First Name"
                      i18n-label="Sign Up|First Name input label@@sign-up-first-name-label"
                      placeholder="First name..."
                      i18n-placeholder="Invite User Modal|First Name input placeholder@@invite-user-modal-first-name-placeholder"
                      [minLength]="2" [maxLength]="128"></form-input>
          <div class="fill-space"></div>
          <form-input fxFlex="48%"
                      [control]="lastNameField"
                      [required]="false"
                      label="Last Name"
                      i18n-label="Sign Up|Last Name input label@@sign-up-last-name-label"
                      placeholder="Last name..."
                      i18n-placeholder="Invite User Modal|Last Name input placeholder@@invite-user-modal-last-name-placeholder"
                      [minLength]="2" [maxLength]="128"></form-input>
        </div>

        <mat-divider class="full-width divider"></mat-divider>

        <school-select *ngIf="school || region || roles.includes(COORDINATOR_ROLE)"
                       [roles]="roles"
                       [selectedGrade]="grade"
                       [selectedRegion]="region"
                       [selectedSchoolType]="schoolType"
                       [selectedSchool]="school"
                       [allowRegionSelect]="allowRegionSelect"
                       [allowSchoolTypeSelect]="allowSchoolTypeSelect"
                       [allowGradeSelect]="allowGradeSelect"
                       [allowSchoolSelect]="allowSchoolSelect"
                       [showGrade]="showGradeSelect"
                       [showRegion]="showRegionSelect"
                       [showSchool]="showSchoolSelect"
                       [clearSchoolAfterSelect]="false"
                       [allowSchoolClear]="allowSchoolSelect"
                       (gradeSelected)="gradeSelected($event.grade)"
                       (regionSelected)="regionSelected($event)"
                       (schoolSelected)="schoolSelected($event)"></school-select>

        <mat-divider *ngIf="school || region" class="full-width divider"></mat-divider>

        <form-input [control]="localeField"
                    label="Locale"
                    i18n-label="Invite User Modal|Invite User Modal locale input label@@invite-user-modal-locale-input-label"
                    [options]="locales"
                    [compareWith]="compareLocales"
                    [displayWith]="displayLocale"></form-input>
      </form>
    </div>

  </permission-checker>
</div>
<div mat-dialog-actions>
  <div>
    <mat-slide-toggle color="primary"
                      (toggleChange)="addMore = !addMore"
                      [disabled]="inProgress || userLoading || !proceedAllowed()"
                      [checked]="addMore">
      <ng-container i18n="Invite User Modal|Add more switcher title@@invite-user-modal-add-more-switcher-title">
        add more
      </ng-container>
    </mat-slide-toggle>
  </div>
  <div class="fill-space"></div>
  <app-button [disabled]="inProgress"
              (clicked)="closeModal()"
              [secondary]="true"
              label="Cancel"
              i18n-label="General|Cancel action label@@general-cancel-action-label"></app-button>
  <span class="btn-spacer"></span>
  <app-button label="Enrol"
              i18n-label="General|Enrol action label@@general-enrol-action-label"
              [disabled]="inProgress || userLoading || !proceedAllowed()"
              (clicked)="proceed()"
              [multiAction]="true"
              [actions]="ctaActions"
              (actionClicked)="ctaActionSelected($event)"></app-button>
</div>
